import EmojiInput from './EmojiInput';

export default EmojiInput;
